import * as React from "react"
import { SVGProps } from "react"

const Lens = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.726 16.403 14.823 13.5a6.565 6.565 0 1 0-1.323 1.323l2.904 2.904a.935.935 0 0 0 1.322-1.322ZM9.59 14.261a4.673 4.673 0 1 1 0-9.345 4.673 4.673 0 0 1 0 9.345Z"
      fill="#9DA3B7"
    />
  </svg>
)

export default Lens